export default __webpack_public_path__ + "static/media/Nish2.2adc1d45.jpeg";